import Button from '../../../../components/Button';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import ListItem from '../../../../components/ListItem';
import { createRootModal } from '../../RootModal';
import './AddressWarningModal.scss';

const AddressWarningModal = createRootModal(({ handleClose, outsideParams }) => {
	const { onConfirm } = outsideParams;

	const isConfirm = !!onConfirm;

	return (
		<div className='AddressWarningModal'>
			<div className='AddressWarningModal__body'>
				<p>If you proceed with this transaction:</p>
				<div className='AddressWarningModal__warning-list FormBlock'>
					<ListItem
						className='AddressWarningModal__warning-listItem'
						icon={<Icon type={Icons.XMARK_CIRCLE_FILL} width={32} height={32} />}
						title='Transaction Gate routing will be disabled'
						bottomSeparator={true}
					/>
					<ListItem
						className='AddressWarningModal__warning-listItem'
						icon={<Icon type={Icons.XMARK_CIRCLE_FILL} width={32} height={32} />}
						title='Energy payment functionality will not be available'
						bottomSeparator={true}
					/>
					<ListItem
						className='AddressWarningModal__warning-listItem'
						icon={<Icon type={Icons.XMARK_CIRCLE_FILL} width={32} height={32} />}
						title='External gas station functionality will be disabled'
					/>
				</div>

				<p>Please confirm that you understand these limitations before continuing.</p>
			</div>

			<div className='AddressWarningModal__buttons'>
				{isConfirm ? (
					<>
						<Button onClick={() => onConfirm()}>Continue</Button>
						<Button styleType='secondary' onClick={handleClose}>
							Cancel
						</Button>
					</>
				) : (
					<Button styleType='white' onClick={handleClose}>
						Got it
					</Button>
				)}
				{/* <Button styleType='white' onClick={handleClose}>Got it</Button> */}
			</div>
		</div>
	);
});

export default AddressWarningModal;
